<template>
  <el-container class="pagination-list change-password-container">
    <div class="change-password-body">
      <el-main>
        <div class="panel">
          <h3>修改密码</h3>
        </div>
        <div class="change-password-content">
          <el-form
            class="change-password-form"
            ref="changePwdForm"
            :rules="changePwdRules"
            :model="changePwdForm"
            label-width="110px"
          >
            <el-form-item label="现有密码" prop="oldPwd" :error="errorMessage">
              <el-input v-focus class="password-input" type="password" v-model="changePwdForm.oldPwd" @blur="verifyPwd(changePwdForm.oldPwd)"></el-input>
            </el-form-item>
            <div class="display-none">
              <input type="text">
              <input type="password">
            </div>
            <el-form-item label="修改密码" prop="changePwd">
              <el-input
                class="password-input"
                type="password"
                @input="checkStrength"
                v-model="changePwdForm.changePwd"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPwd">
              <el-input class="password-input" type="password" v-model="changePwdForm.confirmPwd"></el-input>
            </el-form-item>
            <div class="hint"><i class="el-icon-warning"></i>密码长度为6~16个字符，至少包含数字/字母/字符任意2种组合</div>
            <div class="strength-check">
              <div class="level-block">
                <div class="level-img" :class="level>=1?'red':''">弱</div>
              </div>
              <div class="level-block">
                <div class="level-img" :class="level>=2?'red':''">中</div>
              </div>
              <div class="level-block">
                <div class="level-img" :class="level>=3?'red':''">强</div>
              </div>
            </div>
            <div class="button-block">
              <el-button type="primary" v-bind:disabled="canSubmit" @click="changePwd">确认修改</el-button>
            </div>
          </el-form>
        </div>
      </el-main>
    </div>
  </el-container>
</template>
<script>
export default {
  name: 'changePassword',
  data () {
    let confirmPwdRules = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changePwdForm.changePwd) {
        callback(new Error('两次输入密码不一致!'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('长度在 6 到 16 个字符'))
      } else if (reg.test(value) === false) {
        callback(new Error('至少包含数字/字母/字符2种组合'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    let changePwdRules = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('长度在 6 到 16 个字符'))
      } else if (reg.test(value) === false) {
        callback(new Error('至少包含数字/字母/字符2种组合'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    return {
      lastRouter: '',
      level: '',
      canSubmit: true,
      changePwdForm: {
        oldPwd: '',
        changePwd: '',
        confirmPwd: ''
      },
      changePwdRules: {
        oldPwd: [
          {
            required: true,
            message: '现有密码不可为空',
            trigger: 'blur'
          }
        ],
        changePwd: [
          {
            required: true,
            message: '修改密码不可为空',
            trigger: 'blur'
          },
          {
            validator: changePwdRules,
            trigger: 'blur'
          }
        ],
        confirmPwd: [
          {
            required: true,
            message: '现有密码不可为空',
            trigger: 'blur'
          },
          {
            validator: confirmPwdRules,
            trigger: 'blur'
          }
        ]
      },
      errorMessage: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.lastRouter = from.path
    })
  },
  methods: {
    checkStrength () {
      let reg1 = /\W/
      let reg2 = /[A-Za-z]/
      let reg3 = /[0-9]/
      this.level = 0
      if (reg1.test(this.changePwdForm.changePwd)) {
        // 密码等级增加
        this.level++
      }
      if (reg2.test(this.changePwdForm.changePwd)) {
        this.level++
      }
      if (reg3.test(this.changePwdForm.changePwd)) {
        this.level++
      }
    },
    changePwd () {
      let _this = this
      if (this.errorMessage === '') {
        this.$refs.changePwdForm.validate(valid => {
          if (valid) {
            this.$axios
              .post('/auth-api/login/auth/changePassword', {
                oldPw: _this.changePwdForm.oldPwd,
                newPw: _this.changePwdForm.confirmPwd
              })
              .then(res => {
                // 修改成功
                _this.$message.success('修改成功')
                setTimeout(() => {
                  if (
                    _this.lastRouter === '/setting-security-password' ||
                    _this.lastRouter === '/change-password'
                  ) {
                    _this.$router.push({ name: 'index' })
                  } else {
                    _this.$router.back(-1)
                  }
                }, 2000)
              })
          }
        })
      }
    },
    verifyPwd (oldPw) {
      if (oldPw !== '') {
        this.$axios.post('/auth-api/login/auth/changePassword', {
          oldPw,
          newPw: '',
          verfiyType: 'old'
        }).then(res => {
          this.errorMessage = res.data
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .change-password-container .el-main .content .el-input .el-input__inner {
    height: 28px;
    width: 200px;
  }

  .change-password-container {
    height: 100%;
    padding: 10px;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .change-password-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;
      width: 100%;

      .change-password-content {
        padding-top: 8px;
        height: calc(100% - 75px);

        .display-none {
          display: none;
        }

        .el-form-item__label {
          font-size: 12px;
          color: #181818;
        }

        .change-password-form {
          position: relative;
          top: 35%;
          left: 40%;
          transform: translate(-50%, -70%);
          width: 300px;

          .el-form-item {
            margin-bottom: 17px;
          }
          .password-input {
            ime-mode: active;
          }

          .strength-check {
            position: relative;
            top: -105px;
            left: 320px;
            width: 252px;
            height: 22px;

            .level-block {
              display: inline-block;
              height: 100%;

              .level-img {
                display: inline-block;
                font-size: 13px;
                text-align: center;
                border-radius: 4px;
                height: 22px;
                line-height: 22px;
                width: 70px;
                margin-left: 10px;
                background-color: #f2f1ef;
              }

              .red {
                background-color: #fb615e;
                color: #fff;
              }

              .red-half {
                background: linear-gradient(to right, #fb615e 50%, #f2f1ef 50%);
              }
            }
          }
          .hint {
            width: 400px;
            text-align: right;
            .el-icon-warning {
              color: var(--primary, #659FF0);
              margin-right: 8px;
            }
          }

          .button-block {
            margin: 10px 0 0 100px;
            text-align: center;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/change-password.vue